import classNames from 'classnames';
import * as React from 'react';
import { HtmlDiv } from '~/Partials/Controls/HtmlDiv';
import { Picture } from '~/Partials/Picture/Picture';
import { PictureProfiles } from '~/Partials/Picture/PictureProfiles';
import styles from './SingleContactBlock.module.css';
import { SingleContactBlockBackgroundVariant } from './SingleContactBlockBackgroundVariant.csharp';
import type { SingleContactViewModel } from './SingleContactViewModel.csharp';

// TODO: Ideally we should split this component into entry-level block and reusable SingleContact so that we never
// render SingleContactBlock inside different contexts. This would allow us to remove the `spacing` prop.
export interface SingleContactBlockProps extends SingleContactViewModel {
    spacing?: 'default' | 'small';
}

export const SingleContactBlock = (props: SingleContactBlockProps) => {
    const {
        image,
        heading,
        htmlText,
        backgroundVariant = SingleContactBlockBackgroundVariant.Transparent,
        spacing = 'default',
    } = props;

    return (
        <section
            className={classNames(
                styles.SingleContactBlock,
                styles[`Variant--${backgroundVariant}`],
                spacing !== 'default' && styles[`Variant--${spacing}Spacing`],
                !image && styles['Variant--noImage']
            )}
        >
            <div className={styles.Inner}>
                <div className={styles.Block}>
                    {image && (
                        <Picture
                            {...image}
                            profile={PictureProfiles.fourOfTwelveColumnsElementHorizontal}
                            className={styles.Image}
                        />
                    )}
                    <div className={styles.Content}>
                        <div className={styles.ContentInner}>
                            <h3 className={styles.Title}>{heading}</h3>
                            {htmlText && (
                                <HtmlDiv
                                    html={htmlText}
                                    className={classNames('RichtextContent', styles.RichtextAdjustments)}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
